import axios from "axios";
import Globais, { validateToken } from "../../components/Globais";
import {
  verificarSeTemPeriodoUsuario,
  verificarSeTemPeriodoUsuarioDefinido,
} from "../periodoUsuario/Globais";
import { buscarTodosOsRepresentantesCotaUsuario } from "../representante/Globais";
import { FlapperSpinner } from "react-spinners-kit";

//função que verifica o status de determinada cotaUsuario. retorna o status
export async function buscarStatusCTU(cotaUsuarioId: number) {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        return response.data.status;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}
//função que verifica se CTU está autenticada
export async function verificarCTUChecada(
  cotaUsuarioId: number | undefined | null
) {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        if (response.data.checked === 1 && response.data.active === 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}
//função que atualiza CTU
export async function atualizarCotaUsuarioGlobais(
  cotaUsuarioId: number,
  formData: any
) {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;

    try {
      const response = await axios.put(URL, formData, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}
//função que verifica se as informações do anuncio estão preenchidas
export async function verificarSeMaisInformacoesAnuncioEstaoAusentes(
  cotaUsuarioId: number
) {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        if (
          response.data.situacao === null ||
          response.data.valorCondominio === null ||
          response.data.valorVenda === null ||
          (response.data.situacao === "NAO_QUITADO" &&
            response.data.saldoDevedor === null)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}
//verifica se há pagamento no status passado para uma determinada cota usuario.
export async function verificarPagamentoPorStatus(
  status: string,
  cotaUsuarioId: number | undefined | null
): Promise<boolean> {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/assinatura/pesquisa/status`;

    const formData = {
      status: status,
    };

    try {
      const response = await axios.post(URL, formData, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        const resultado = await response.data.filter((p: any) => {
          if (p.cotasUsuariosId === cotaUsuarioId) {
            return p;
          } else {
            return null;
          }
        });

        if (resultado.length === 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}
//função que regulariza situação CTU
export async function regularizarSituacaoCTU(
  cotaUsuarioId: number,
  status: string
) {
  const regularizarAutenticacao = async () => {
    const resultadoChecado = verificarCTUChecada(cotaUsuarioId);
    if (await resultadoChecado) {
      if (status !== "AUTENTICADA_NIVEL1" && status !== "AUTENTICADA_NIVEL2") {
        const formData = {
          status: "AUTENTICADA_NIVEL1",
        };
        const resultadoCTU = await atualizarCotaUsuarioGlobais(
          cotaUsuarioId,
          formData
        );
        if (resultadoCTU) {
          document.location.reload();
        }
      }
    } else {
      if (status !== "AGUARDANDO_AUTENTICACAO") {
        const formData = {
          status: "AGUARDANDO_AUTENTICACAO",
        };
        const resultadoCTU = await atualizarCotaUsuarioGlobais(
          cotaUsuarioId,
          formData
        );
        if (resultadoCTU) {
          document.location.reload();
        }
      }
    }
  };

  switch (status) {
    case "AGUARDANDO_CADASTRO":
    case "AGUARDANDO_APTO":
    case "AGUARDANDO_APTOMAISINFO":
    case "AGUARDANDO_TITULARIDADE":
    case "AGUARDANDO_REPRESENTANTE":
    case "AGUARDANDO_COMPROVANTE":
    case "AGUARDANDO_COTA":
    case "AGUARDANDO_DEFINICAO_ANUNCIO":
    case "CANCELADA":
    case "VENDIDA_MC":
    case "VENDIDA_PROPRIO":
      break;
    case "AGUARDANDO_PERIODOS":
      const resultadoPagamentoAGPE = verificarPagamentoPorStatus(
        "PENDENTE",
        cotaUsuarioId
      );

      if (await resultadoPagamentoAGPE) {
        const formData = {
          status: "AGUARDANDO_PAGAMENTO",
        };
        const resultadoCTU = atualizarCotaUsuarioGlobais(
          cotaUsuarioId,
          formData
        );
        if (await resultadoCTU) {
          break;
        }
      } else {
        const resultadoPagamentoAGPE = verificarPagamentoPorStatus(
          "ATIVA",
          cotaUsuarioId
        );
        if (await resultadoPagamentoAGPE) {
          const resultadoAnuncio =
            verificarSeMaisInformacoesAnuncioEstaoAusentes(cotaUsuarioId);

          if (await resultadoAnuncio) {
            const formData = {
              status: "AGUARDANDO_MAISINFO_ANUNCIO",
            };
            const resultadoCTU = atualizarCotaUsuarioGlobais(
              cotaUsuarioId,
              formData
            );
            if (await resultadoCTU) {
              return true;
            } else {
              return false;
            }
          } else {
            const resultadoDefinido1 =
              verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);

            if (await resultadoDefinido1) {
              const representantes =
                await buscarTodosOsRepresentantesCotaUsuario(cotaUsuarioId);

              if (await resultadoDefinido1) {
                const representantes =
                  await buscarTodosOsRepresentantesCotaUsuario(cotaUsuarioId);

                if (representantes) {
                  if (
                    representantes[0].checked === 0 &&
                    representantes[0].dataVencimento === null
                  ) {
                    const formData = {
                      status: "AGUARDANDO_PROCURACAO",
                    };
                    const resultado = atualizarCotaUsuarioGlobais(
                      cotaUsuarioId,
                      formData
                    );
                    if (await resultado) {
                      console.log("Aguardando procuração");
                    }
                  } else {
                    const formData = {
                      status: "AGUARDANDO_AUTENTICACAO",
                    };
                    const resultadoCTU = atualizarCotaUsuarioGlobais(
                      cotaUsuarioId,
                      formData
                    );
                  }
                } else {
                  const formData = {
                    status: "AGUARDANDO_AUTENTICACAO",
                  };
                  const resultadoCTU = atualizarCotaUsuarioGlobais(
                    cotaUsuarioId,
                    formData
                  );
                }
              } else {
                const resultadoSeTemPeriodos =
                  verificarSeTemPeriodoUsuario(cotaUsuarioId);
                if (await resultadoSeTemPeriodos) {
                  const formData = {
                    status: "AGUARDANDO_DEFINICAO_PERIODOS",
                  };
                  const resultadoCTU = atualizarCotaUsuarioGlobais(
                    cotaUsuarioId,
                    formData
                  );
                  if (await resultadoCTU) {
                    break;
                  }
                } else {
                  break;
                }
              }
            }
          }
        } else {
          const resultadoDefinido1 =
            verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);

          if (await resultadoDefinido1) {
            const representantes = await buscarTodosOsRepresentantesCotaUsuario(
              cotaUsuarioId
            );

            if (representantes) {
              if (
                representantes[0].checked === 0 &&
                representantes[0].dataVencimento === null
              ) {
                const formData = {
                  status: "AGUARDANDO_PROCURACAO",
                };
                const resultado = atualizarCotaUsuarioGlobais(
                  cotaUsuarioId,
                  formData
                );
                if (await resultado) {
                  console.log("Aguardando procuração");
                }
              } else {
                regularizarAutenticacao();
              }
            } else {
              regularizarAutenticacao();
            }
          } else {
            const resultadoSeTemPeriodos =
              verificarSeTemPeriodoUsuario(cotaUsuarioId);
            if (await resultadoSeTemPeriodos) {
              const formData = {
                status: "AGUARDANDO_DEFINICAO_PERIODOS",
              };
              const resultadoCTU = atualizarCotaUsuarioGlobais(
                cotaUsuarioId,
                formData
              );
              if (await resultadoCTU) {
                break;
              }
            } else {
              break;
            }
          }
        }
      }

      break;
    case "AGUARDANDO_DEFINICAO_PERIODOS":
      const resultadoPagamentoAGDPE = verificarPagamentoPorStatus(
        "PENDENTE",
        cotaUsuarioId
      );

      if (await resultadoPagamentoAGDPE) {
        const formData = {
          status: "AGUARDANDO_PAGAMENTO",
        };
        const resultadoCTU = atualizarCotaUsuarioGlobais(
          cotaUsuarioId,
          formData
        );
        if (await resultadoCTU) {
          document.location.reload();
        }
      } else {
        const resultadoPagamentoAGPE = verificarPagamentoPorStatus(
          "ATIVA",
          cotaUsuarioId
        );
        if (await resultadoPagamentoAGPE) {
          const resultadoAnuncio =
            verificarSeMaisInformacoesAnuncioEstaoAusentes(cotaUsuarioId);

          if (await resultadoAnuncio) {
            const formData = {
              status: "AGUARDANDO_MAISINFO_ANUNCIO",
            };
            const resultadoCTU = atualizarCotaUsuarioGlobais(
              cotaUsuarioId,
              formData
            );
            if (await resultadoCTU) {
              document.location.reload();
              return true;
            } else {
              return false;
            }
          } else {
            const resultadoDefinido =
              verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
            if (await resultadoDefinido) {
              const representantes =
                await buscarTodosOsRepresentantesCotaUsuario(cotaUsuarioId);

              if (representantes) {
                if (
                  representantes[0].checked === 0 &&
                  representantes[0].dataVencimento === null
                ) {
                  const formData = {
                    status: "AGUARDANDO_PROCURACAO",
                  };
                  const resultado = atualizarCotaUsuarioGlobais(
                    cotaUsuarioId,
                    formData
                  );
                  if (await resultado) {
                    console.log("Aguardando procuração");
                  }
                } else {
                  regularizarAutenticacao();
                }
              } else {
                regularizarAutenticacao();
              }
            } else {
            }
          }
        } else {
          const resultadoDefinido =
            verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
          if (await resultadoDefinido) {
            const representantes = await buscarTodosOsRepresentantesCotaUsuario(
              cotaUsuarioId
            );

            if (representantes) {
              if (
                representantes[0].checked === 0 &&
                representantes[0].dataVencimento === null
              ) {
                const formData = {
                  status: "AGUARDANDO_PROCURACAO",
                };
                const resultado = atualizarCotaUsuarioGlobais(
                  cotaUsuarioId,
                  formData
                );
                if (await resultado) {
                  document.location.reload();

                  console.log("Aguardando procuração");
                }
              } else {
                regularizarAutenticacao();
              }
            } else {
              regularizarAutenticacao();
            }
          } else {
            console.log("periodo não definido");
          }
        }
      }

      break;
    default:
      const resultadoPagamento = verificarPagamentoPorStatus(
        "PENDENTE",
        cotaUsuarioId
      );

      if (await resultadoPagamento) {
        if (status !== "AGUARDANDO_PAGAMENTO") {
          const formData = {
            status: "AGUARDANDO_PAGAMENTO",
          };
          const resultadoCTU = atualizarCotaUsuarioGlobais(
            cotaUsuarioId,
            formData
          );
          if (await resultadoCTU) {
            document.location.reload();
          }
        }
      } else {
        const resultadoPagamentoAGPE = verificarPagamentoPorStatus(
          "ATIVA",
          cotaUsuarioId
        );
        if (await resultadoPagamentoAGPE) {
          const resultadoAnuncio =
            verificarSeMaisInformacoesAnuncioEstaoAusentes(cotaUsuarioId);

          if (await resultadoAnuncio) {
            if (status !== "AGUARDANDO_MAISINFO_ANUNCIO") {
              const formData = {
                status: "AGUARDANDO_MAISINFO_ANUNCIO",
              };
              const resultadoCTU = atualizarCotaUsuarioGlobais(
                cotaUsuarioId,
                formData
              );
              if (await resultadoCTU) {
                document.location.reload();
              }
            }
          } else {
            const resultadoDefinido1 =
              await verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);

            if (resultadoDefinido1) {
              const representantes =
                await buscarTodosOsRepresentantesCotaUsuario(cotaUsuarioId);

              if (representantes) {
                if (
                  representantes[0].checked === 0 &&
                  representantes[0].dataVencimento === null
                ) {
                  if (status !== "AGUARDANDO_PROCURACAO") {
                    const formData = {
                      status: "AGUARDANDO_PROCURACAO",
                    };
                    const resultado = atualizarCotaUsuarioGlobais(
                      cotaUsuarioId,
                      formData
                    );
                    if (await resultado) {
                      document.location.reload();
                    }
                  }
                } else {
                  const resultadoChecado = verificarCTUChecada(cotaUsuarioId);
                  if (await resultadoChecado) {
                    if (
                      status !== "AUTENTICADA_NIVEL1" &&
                      status !== "AUTENTICADA_NIVEL2"
                    ) {
                      const formData = {
                        status: "AUTENTICADA_NIVEL1",
                      };
                      const resultadoCTU = atualizarCotaUsuarioGlobais(
                        cotaUsuarioId,
                        formData
                      );
                    }
                  } else {
                    if (status !== "AGUARDANDO_AUTENTICACAO") {
                      const formData = {
                        status: "AGUARDANDO_AUTENTICACAO",
                      };
                      const resultadoCTU = await atualizarCotaUsuarioGlobais(
                        cotaUsuarioId,
                        formData
                      );
                      if (resultadoCTU) {
                        document.location.reload();
                      }
                    }
                  }
                }
              } else {
                regularizarAutenticacao();
              }
            } else {
              const resultadoSeTemPeriodos =
                verificarSeTemPeriodoUsuario(cotaUsuarioId);
              if (await resultadoSeTemPeriodos) {
                const formData = {
                  status: "AGUARDANDO_DEFINICAO_PERIODOS",
                };
                const resultadoCTU = atualizarCotaUsuarioGlobais(
                  cotaUsuarioId,
                  formData
                );
                if (await resultadoCTU) {
                  break;
                }
              } else {
                const formData = {
                  status: "AGUARDANDO_PERIODOS",
                };
                const resultadoCTU = atualizarCotaUsuarioGlobais(
                  cotaUsuarioId,
                  formData
                );
              }
            }
          }
        } else {
          const resultadoDefinido1 = await verificarSeTemPeriodoUsuarioDefinido(
            cotaUsuarioId
          );

          if (resultadoDefinido1) {
            const representantes = await buscarTodosOsRepresentantesCotaUsuario(
              cotaUsuarioId
            );

            if (representantes) {
              if (
                representantes[0].checked === 0 &&
                representantes[0].dataVencimento === null
              ) {
                if (status !== "AGUARDANDO_PROCURACAO") {
                  const formData = {
                    status: "AGUARDANDO_PROCURACAO",
                  };
                  const resultado = atualizarCotaUsuarioGlobais(
                    cotaUsuarioId,
                    formData
                  );
                  if (await resultado) {
                    document.location.reload();
                  }
                }
              } else {
                const resultadoChecado = verificarCTUChecada(cotaUsuarioId);
                if (await resultadoChecado) {
                  if (
                    status !== "AUTENTICADA_NIVEL1" &&
                    status !== "AUTENTICADA_NIVEL2"
                  ) {
                    const formData = {
                      status: "AUTENTICADA_NIVEL1",
                    };
                    const resultadoCTU = atualizarCotaUsuarioGlobais(
                      cotaUsuarioId,
                      formData
                    );
                  }
                } else {
                  if (status !== "AGUARDANDO_AUTENTICACAO") {
                    const formData = {
                      status: "AGUARDANDO_AUTENTICACAO",
                    };
                    const resultadoCTU = await atualizarCotaUsuarioGlobais(
                      cotaUsuarioId,
                      formData
                    );
                    if (resultadoCTU) {
                      document.location.reload();
                    }
                  }
                }
              }
            } else {
              regularizarAutenticacao();
            }
          } else {
            const resultadoSeTemPeriodos =
              verificarSeTemPeriodoUsuario(cotaUsuarioId);
            if (await resultadoSeTemPeriodos) {
              const formData = {
                status: "AGUARDANDO_DEFINICAO_PERIODOS",
              };
              const resultadoCTU = atualizarCotaUsuarioGlobais(
                cotaUsuarioId,
                formData
              );
              if (await resultadoCTU) {
                break;
              }
            } else {
              const formData = {
                status: "AGUARDANDO_PERIODOS",
              };
              const resultadoCTU = atualizarCotaUsuarioGlobais(
                cotaUsuarioId,
                formData
              );
            }
          }
        }
      }
      break;

    // const Token = validateToken();

    // if (Token) {
    //   const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;

    //   try {
    //     const response = await axios.put(URL, formData,{
    //       headers: { Authorization: Token.AuthStr },
    //     });
    //     if (response) {
    //       return true;
    //     }else{
    //       return false;
    //     }
    //   } catch (e) {
    //     console.log(e);
    //     return false;
    //   }
    // } else {
    //   document.location.href = "/login";
    //   return false;
    // }
  }
}

export async function verificarSeTemArquivos(cotaUsuarioId: number) {
  const formData = new FormData();
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/arquivo-cota-usuario/cotaUsuario/${cotaUsuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: {
          Authorization: Token.AuthStr,
          "Content-type": "multipart/form-data",
        },
      });
      if (response.data.length > 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  }
}
